export const createComboChart = (el, g) => el && new g.visualization.ComboChart(el);
export const createColumnChart = (el, g) => el && new g.visualization.ColumnChart(el);
